import React from 'react';
import { useAppSelector } from '../app/hooks';
import { OrderingSelectors } from 'polygon-ordering';
import Text from '../components/Text';
import uppercaseInitial from '../utils/uppercaseInitial';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';
import MemberBalances from '../components/MemberBalances';
import toDollarString from '../utils/toDollarString';
import Wallet from '../components/Wallet';
import RedcatBarcode from '../components/RedcatBarcode';
import RedcatQrCode from '../components/RedcatQrCode';

const { getMember } = OrderingSelectors;

export const REWARDS_SCREEN_ROUTE = '/rewards';

const RewardsScreen = () => {
  const member = useAppSelector(getMember);
  const loyaltyPointsRing = useAppSelector(state => state.config.loyaltyPointsRing);
  const barcodeView = useAppSelector(state => state.config.loyaltyBarcodeView);
  const isWalletEnabled = useAppSelector(state => state.config.enableLoyaltyWallet);

  const { t } = useTranslation();

  const barcodeOptions: BarcodeOptions = {
    value: member?.barcode!,
    text: member?.memberNumber!,
  };

  return (
    <div>
      <div className="mx-auto">
        <div>
          <Row>
            <Col className={loyaltyPointsRing ? '' : 'text-center'}>
              <Text
                themeKey="loyaltyGreeting"
                value={
                  loyaltyPointsRing
                    ? t('loyaltyGreeting')
                    : t('loyaltyGreeting') + ' ' + uppercaseInitial(member?.givenName!) + '!'
                }
              />
              {loyaltyPointsRing && (
                <>
                  <br />
                  <Text
                    themeKey="loyaltyGreeting"
                    value={uppercaseInitial(member?.givenName!) + '!'}
                  />
                </>
              )}
            </Col>
            {loyaltyPointsRing && (
              <Col style={{ textAlign: 'right' }}>
                <div>
                  <Text
                    themeKey="balanceAmountMemberModal"
                    value={toDollarString(member?.moneyBalance!)}
                  />
                  <br />
                  <Text value={t('memberMoney')} themeKey="memberMoney" />
                </div>
              </Col>
            )}
          </Row>
        </div>
        <div className=" mx-auto  mt-2 ">
          {!loyaltyPointsRing && (
            <div className="text-center">
              <Text value={t('memberPointsTitle')} themeKey="memberPointsTitle" />
            </div>
          )}
          <div className="my-4 text-center">
            <MemberBalances loyaltyView loyaltyPointsRing={loyaltyPointsRing} />
          </div>
          {!barcodeView && <RedcatQrCode />}

          {barcodeView && (
            <div
              className="  shadow p-1 position-relative"
              style={{ borderRadius: 10, border: '2px solid lightgrey' }}
            >
              <RedcatBarcode barcodeOptions={barcodeOptions} showMemberDetails />
            </div>
          )}

          {isWalletEnabled && (
            <div>
              <div className="mt-5 text-center">
                <Text value={t('loyaltyWallet')} themeKey="loyaltyWalletTitle" />
              </div>
              <Wallet />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardsScreen;
